/**
 * Organised PDP: hide Essential Trust Badges payment-icon banners.
 * The app embed injects them with inline styles after load; CSS alone is not enough.
 */
(function () {
  const isOrganised = () => Boolean(document.querySelector('.product--organised'));

  const isPaymentIconBanner = (node) => {
    if (!(node instanceof Element)) return false;
    if (node.classList.contains('icon-block-container')) return true;
    if (node.matches?.('[data-banner]') && node.querySelector('.icon-block-container, .icon-block')) {
      return true;
    }
    return Boolean(
      node.querySelector?.(
        '.icon-block-container, [style*="payment-icons/"], [style*="Mastercard"], [style*="shoppay"]'
      )
    );
  };

  const hideNode = (node) => {
    if (!(node instanceof HTMLElement)) return;
    if (node.dataset.gmaEssentialPayHidden === '1') return;
    node.dataset.gmaEssentialPayHidden = '1';
    node.hidden = true;
    node.setAttribute('aria-hidden', 'true');
    node.style.setProperty('display', 'none', 'important');
  };

  const hideEssentialPaymentBadges = () => {
    if (!isOrganised()) return;

    document.querySelectorAll('.icon-block-container').forEach((el) => {
      hideNode(el.closest('[data-banner]') || el);
    });

    document.querySelectorAll('[data-banner]').forEach((banner) => {
      if (isPaymentIconBanner(banner)) hideNode(banner);
    });
  };

  hideEssentialPaymentBadges();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEssentialPaymentBadges, { once: true });
  }

  window.addEventListener('load', hideEssentialPaymentBadges, { once: true });

  const observer = new MutationObserver(() => {
    hideEssentialPaymentBadges();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(() => observer.disconnect(), 15000);
})();
